import {ascend, pipe, sort} from 'ramda'

import {Offer} from '../../../offer/types/offer'
import {Room} from '../../types/room'
import {getNightlyDisplayTotalPrice} from '../transformSapiRoomsResponse/utils/price'

const firstOfferSelector = (room: Room) => room.offers[0] || null

const getOfferNightlyDisplayTotal = (offer: Offer) => {
  const displayTotalPrice = getNightlyDisplayTotalPrice(offer.prices || [])

  // TODO (@Core): displayTotalPrice could technically be null according to types
  return Math.round(displayTotalPrice as number)
}

const getFirstOfferNightlyDisplayTotal = ascend(
  pipe(firstOfferSelector, getOfferNightlyDisplayTotal)
)

/**
 * Sort rooms by lowest prices and canPayLater (secondary)
 * @param rooms - The rooms to sort
 * @returns The sorted rooms
 */
export const sortRoomsByNightlyDisplayTotalAsc = (rooms: Room[]): Room[] => {
  return pipe(
    sort(getFirstOfferNightlyDisplayTotal) // rooms -> number
  )(rooms)
}
